<style lang="less" type="text/less">
    *{
        padding:0;
        margin:0;
        border:none;
    }
    .wrapper{
        font-size:14px;
    }
    .router_view{
        &.blur{
            filter: blur(5px);
        }
    }
</style>
<template>
    <div class="wrapper container">
        <router-view class="router_view"></router-view>
        <toast></toast>
    </div>
</template>
<script type="text/ecmascript-6">
    import toast from '../components/Toast.vue';
    import Store from '../lib/store';
    import event from '../lib/event';
    import preload from '../lib/preload';
    import userService from '../lib/UserService';
    import $ from 'jquery';


    window.userService = userService;
    export default {
        data() {
            return {
                minHeight:0,
            }
        },
        computed: {},
        methods: {
            initMinHeight(){
                Store.setMinHeight($(window).height());
            }
        },
        components: {toast},
        mounted() {
            event.on('force_logout',()=>{
                userService.logout();
            })
            this.initMinHeight();
            $(window).on('resize',this.initMinHeight.bind(this));
        }
    }
</script>


// WEBPACK FOOTER //
// app.vue?2165fb96